/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { UpdateCourseSectionOptions, UpdateCourseSectionStatus200, UpdateCourseSectionStatus422 } from '../models/UpdateCourseSection'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateCourseSection } from '../clients/axios/updateCourseSection'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateCourseSectionMutationKey = () => [{ url: '/admin/course/:course_id/sections/:section_id' }] as const

export function updateCourseSectionMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = updateCourseSectionMutationKey()
  return mutationOptions<UpdateCourseSectionStatus200, ResponseErrorConfig<UpdateCourseSectionStatus422>, UpdateCourseSectionOptions, TContext>({
    mutationKey,
    mutationFn: async({ path, body }) => {
      return await updateCourseSection({ ...config, path, body, throwOnError: true })
    },
  })
}

/**
 * @summary Update Course Section
 * {@link /admin/course/:course_id/sections/:section_id}
 */
export function useUpdateCourseSection<TContext>(options: {
  mutation?: UseMutationOptions<UpdateCourseSectionStatus200, ResponseErrorConfig<UpdateCourseSectionStatus422>, UpdateCourseSectionOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? updateCourseSectionMutationKey()

  const baseOptions = updateCourseSectionMutationOptions(config) as UseMutationOptions<UpdateCourseSectionStatus200, ResponseErrorConfig<UpdateCourseSectionStatus422>, UpdateCourseSectionOptions, TContext>

  return useMutation<UpdateCourseSectionStatus200, ResponseErrorConfig<UpdateCourseSectionStatus422>, UpdateCourseSectionOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<UpdateCourseSectionStatus200, ResponseErrorConfig<UpdateCourseSectionStatus422>, UpdateCourseSectionOptions, TContext>
}
